import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
import { SectionTitle } from './ui/Section';
const collapseTransition = {
  duration: 0.22,
  ease: [0.23, 1, 0.32, 1] as const
};
export function Faq() {
  const [open, setOpen] = useState(0);
  return <section className="bg-white px-4 py-12 md:py-16" data-id="element-71" data-mp="1gal1dn7qnrd8">
      <div className="mx-auto max-w-3xl" data-id="element-72" data-mp="2dzemhm8wv9jy">
        <SectionTitle data-id="element-73" data-mp="2dyd93b4faaz2">Frequently asked questions</SectionTitle>
        <div className="mt-8 space-y-3" data-id="element-74" data-mp="292edp3kofsp5">
          {faqs.map(([question, answer], index) => <div key={question} className={`overflow-hidden rounded-2xl border-2 bg-white transition-colors duration-150 ease-out ${open === index ? 'border-berry-600 shadow-md' : 'border-berry-600/15'}`} data-id="element-75" data-mp="2418o3embclju" data-mpi={index}>
              <button className="flex w-full items-center justify-between gap-3 p-4 text-left text-xs font-extrabold uppercase text-plum-950 md:text-sm" onClick={() => setOpen(open === index ? -1 : index)} aria-expanded={open === index} data-id="element-76" data-mp="skqqhb6zccvm">
                {question}
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-berry-600 transition-transform duration-200 ease-out ${open === index ? 'rotate-180' : ''}`} data-id="element-77" data-mp="fk9uvwtpf5vw" />
              </button>
              <AnimatePresence initial={false} data-id="element-78" data-mp="6qez3feh2rsx">
                {open === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={collapseTransition} className="border-t border-berry-600/10 px-4 py-3 text-sm leading-relaxed text-muted" data-id="element-79" data-mp="biessq3y8oh2">
                    {answer}
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}